// extracted by mini-css-extract-plugin
export var active = "_eu-7";
export var container = "_eu-0";
export var evenWidth = "_eu-4";
export var large = "_eu-5";
export var outlet = "_eu-8";
export var slide = "_eu-2";
export var small = "_eu-6";
export var tab = "_eu-3";
export var tabs = "_eu-1";